import { NgComponentOutlet } from '@angular/common';
import { Component, computed, signal, Type } from '@angular/core';
import { JsxgraphExampleComponent, MultiGraphExampleComponent, SliderExampleComponent } from '@examdojo/math-widget';

interface GraphExample {
  id: string;
  title: string;
  description: string;
  component: Type<unknown>;
}

@Component({
  selector: 'exam-app-graph',
  imports: [NgComponentOutlet],
  templateUrl: './graph.component.html',
  styles: [
    `
      :host {
        @apply block h-full;
      }
    `,
  ],
  host: { class: 'block h-full' },
})
export class GraphComponent {
  readonly examples: GraphExample[] = [
    {
      id: 'basic',
      title: 'Basic Example',
      description: 'Function graph, point, and circle',
      component: JsxgraphExampleComponent,
    },
    {
      id: 'slider',
      title: 'Interactive Slider',
      description: 'Sine & cosine waves with sliders',
      component: SliderExampleComponent,
    },
    {
      id: 'multi-graph',
      title: 'Multiple Graphs',
      description: 'Four function graphs in a grid',
      component: MultiGraphExampleComponent,
    },
  ];

  readonly selectedExample = signal<GraphExample>(this.examples[0]);
  readonly selectedExampleId = computed(() => this.selectedExample().id);

  selectExample(example: GraphExample): void {
    this.selectedExample.set(example);
  }
}
